import { ColumnsType } from "antd/lib/table";
import { IColumn } from "typings/global";
import useTranslation from "utils/hooks/useTranslation";

const columnsTable = () => {
  const collums: Array<IColumn> = [
    {
      key: "orderNumber",
      width: "20%",
      title: useTranslation({ id: "order" }),
      dataIndex: "orderNumber",
      render: (orderNumber: ColumnsType<string>) => `${orderNumber}`,
    },
    {
      key: "code",
      width: "20%",
      title: useTranslation({ id: "code" }),
      dataIndex: "code",
      render: (code: ColumnsType<string>) => `${code}`,
    },
    {
      key: "description",
      width: "45%",
      title: useTranslation({ id: "description" }),
      dataIndex: "description",
      render: (description: ColumnsType<string>) => `${description}`,
    },
    {
      key: "quantity",
      width: "15%",
      title: useTranslation({ id: "quantity" }),
      dataIndex: "quantity",
      render: (quantity: ColumnsType<string>) => `${quantity}`,
    },
  ];
  return collums;
};

export default columnsTable;
